import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgIf, NgClass } from '@angular/common';
import { ActionService } from 'src/app/shared/services/action/action.service';
import { ProjectActionSummaryHomeComponent } from '../project-action-summary-home/project-action-summary-home.component';
import { ProjectActionAgeingHomeComponent } from '../project-action-ageing-home/project-action-ageing-home.component';
import { ProjectActionTatHomeComponent } from '../project-action-tat-home/project-action-tat-home.component';

@Component({
    selector: 'app-project-action-home',
    templateUrl: './project-action-home.component.html',
    styleUrls: ['./project-action-home.component.scss'],
    imports: [NgIf, NgClass, ProjectActionSummaryHomeComponent, ProjectActionAgeingHomeComponent, ProjectActionTatHomeComponent]
})
export class ProjectActionHomeComponent implements OnInit {
  activeTab: string | null = null;
  tabList: any = []
  tabVisiblity: any = {
    status_overview: Helpers.isTabVisible(false, 'action_summary_v2', 'count'),
    open_actionables: Helpers.isTabVisible(false, 'action_summary_v2', 'ageing'),
    closed_actionables: Helpers.isTabVisible(false, 'action_summary_v2', 'tat')
  }
  constructor(private router: Router, private route: ActivatedRoute, private actionService: ActionService) { }

  ngOnInit(): void {
    this.tabVisiblity = {
      status_overview: Helpers.isTabVisible(false, 'action_summary_v2', 'count'),
      open_actionables: Helpers.isTabVisible(false, 'action_summary_v2', 'ageing'),
      closed_actionables: Helpers.isTabVisible(false, 'action_summary_v2', 'tat')
    }
    if (this.tabVisiblity.status_overview)
      this.tabList.push('status_overview')

    if (this.tabVisiblity.open_actionables)
      this.tabList.push('open_actionables')

    if (this.tabVisiblity.closed_actionables)
      this.tabList.push('closed_actionables')

    let activeTab = (this.tabList && this.tabList.length) ? this.tabList[0] : null;
    // Initialize activeTab based on query parameters
    this.route.queryParams.subscribe(params => {
      let tab = (this.tabList.indexOf(params['active_tab']) >= 0) ? params['active_tab'] : activeTab; // Default to 'count' if no query param
      this.toggleTab(tab)
    });
    // Redirect to unauthorized page if action tab not enabled for the user
    if (Helpers.brandDetails.module_configuration_v2?.action_summary_v2 && !Helpers.brandDetails.module_configuration_v2?.action_summary_v2.visible) {
      this.router.navigate(["message"], { queryParams: { status: '401' } });
    }
  }

  // based on the tab selection it's highlight the active tab and change the page url accordingly
  toggleTab(tab: string): void {
    this.actionService.drilldownTable = []
    this.activeTab = tab;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { active_tab: tab },
      queryParamsHandling: 'merge'
    });
  }
}
